import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  useTheme,
  MenuItem,
} from "@mui/material";
import { useFormik } from "formik";
import moment from "moment";

const EditAbsensiModal = ({ open, dataEdit, onClose, onSubmit }) => {
  const theme = useTheme();

  const typeAbsensiOptions = [
    {
      id: 1,
      name: "Shift 1 Pagi",
      time: "07:00:00",
      type_absen: "Double Absen",
    },
    {
      id: 2,
      name: "Shift 2 Siang",
      time: "14:00:00",
      type_absen: "Double Absen",
    },
    {
      id: 3,
      name: "Shift Middle",
      time: "11:00:00",
      type_absen: "Double Absen",
    },
    {
      id: 4,
      name: "Shift 4",
      time: "08:00:00",
      type_absen: "Triple Absen",
    },
  ];

  const formik = useFormik({
    initialValues: {
      shift_absen: "",
      telat_menit: "",
    },
    onSubmit: (values) => {
      const reqData = {
        shift_absen: values.shift_absen,
        telat_menit: values.telat_menit,
      };
      onSubmit(reqData);
      formik.resetForm();
      onClose();
    },
  });

  useEffect(() => {
    if (open) {
      formik.setValues({
        shift_absen: dataEdit.shift_absen || "",
        telat_menit: (dataEdit?.telat_menit ?? "0").toString(),
      });
    } else if (!dataEdit) {
      formik.resetForm();
    }
  }, [open, dataEdit]);

  useEffect(() => {
    const selectedShift = typeAbsensiOptions.find(
      (item) => item.name === formik.values.shift_absen
    );

    if (selectedShift && dataEdit) {
      const startTime = moment(selectedShift.time, "HH:mm:ss");
      const checkInTime = moment(dataEdit.waktu_masuk, "HH:mm:ss");

      if (startTime.isValid() && checkInTime.isValid()) {
        let lateMinutes = checkInTime.diff(startTime, "minutes");
        if (lateMinutes < 0) lateMinutes = 0;
        formik.setFieldValue("telat_menit", lateMinutes.toString());
      }
    }
  }, [dataEdit, formik.values.shift_absen]);

  if (!open) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Absensi</DialogTitle>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                select
                fullWidth
                label="Shift Absen"
                name="shift_absen"
                value={formik.values.shift_absen}
                onChange={formik.handleChange}
                error={
                  formik.touched.shift_absen &&
                  Boolean(formik.errors.shift_absen)
                }
                helperText={
                  formik.touched.shift_absen && formik.errors.shift_absen
                }
              >
                {typeAbsensiOptions.map((item) => (
                  <MenuItem
                    key={item.name}
                    value={item.name}
                    disabled={item.type_absen !== dataEdit.mode_absen}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                disabled
                label="Menit Telat"
                name="telat_menit"
                value={formik.values.telat_menit}
                onChange={formik.handleChange}
                error={
                  formik.touched.telat_menit &&
                  Boolean(formik.errors.telat_menit)
                }
                helperText={
                  formik.touched.telat_menit && formik.errors.telat_menit
                }
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            color="inherit"
            onClick={onClose}
            sx={{ fontSize: "14px", fontWeight: "bold", padding: "10px 20px" }}
          >
            Batal
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.background.alt,
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              "&:hover": {
                backgroundColor: theme.palette.secondary[500],
              },
            }}
          >
            Kirim
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditAbsensiModal;
